import ActionTypes from "./ActionTypes";

const addNewVendor = (payload) => {
  return {
    type: ActionTypes.ADD_NEW_VENDOR,
    payload,
  };
};

const getYourVendors = (payload) => {
  return {
    type: ActionTypes.GET_YOUR_VENDORS,
    payload,
  };
};
const getVendorDetails = (payload) => {
  return {
    type: ActionTypes.GET_VENDOR_DETAILS,
    payload,
  };
};

const getFindVendors = (payload) => {
  return {
    type: ActionTypes.GET_FIND_VENDORS,
    payload,
  };
};

const removeVendorFromEvent = (payload) => {
  return {
    type: ActionTypes.REMOVE_VENDOR_FROM_EVENT,
    payload,
  };
};

const getFindVendorsByCat = (payload) => {
  return {
    type: ActionTypes.GET_FIND_VENDORS_BY_CATEGORY,
    payload,
  };
};

const clearYourVendors = () => {
  return {
    type: ActionTypes.CLEAR_YOUR_VENDORS,
  };
};
const clearFindVendors = () => {
  return {
    type: ActionTypes.CLEAR_FIND_VENDORS,
  };
};
const clearFindVendorsByCat = () => {
  return {
    type: ActionTypes.CLEAR_FIND_VENDORS_BY_CATEGORY,
  };
};

const getSubContacts = (payload) => {
  return {
    type: ActionTypes.GET_SUB_CONTACTS,
    payload,
  };
};

const clearSubContacts = () => {
  return {
    type: ActionTypes.CLEAR_SUB_CONTACTS,
  };
};

const updateSubContacts = (payload) => {
  return {
    type: ActionTypes.UPDATE_SUB_CONTACTS,
    payload,
  };
};
const removeSubVendor = (payload) => {
  return {
    type: ActionTypes.REMOVE_SUB_VENDOR,
    payload,
  };
};


export {
  addNewVendor,
  getYourVendors,
  clearYourVendors,
  getFindVendors,
  clearFindVendors,
  clearFindVendorsByCat,
  getFindVendorsByCat,
  removeVendorFromEvent,
  getSubContacts,
  clearSubContacts,
  updateSubContacts,
  getVendorDetails,
  removeSubVendor,
};
